import { useMutation } from '@apollo/client';
import { PROFESSIONAL_INVITE_COLLEAGUE } from '../../services/graphql/mutations/professional';
import { useCallback } from 'react';

type InviteColleagueType = {
  clientId: string
  email: string
  message: string
}
export const useInviteColleague = () => {
  const [inviteColleague, { loading }] = useMutation(PROFESSIONAL_INVITE_COLLEAGUE);

  const createData = useCallback(async (values: InviteColleagueType) => {
    try {
      const { data } = await inviteColleague({
        variables: {
          input: {
            clientId: values.clientId,
            email: values.email,
            message: values.message
          },
        }
      });
      return data?.professionalAddColleague;
    } catch (error: any) {
      console.log('Error in inviteColleague: ', error?.graphQLErrors[0].message);
    }
  }, [inviteColleague]);

  return {
    create: createData,
    loading
  };
};